import { useLocation } from 'react-router';
import { Flex, Text } from '@/uicomponents';
import { useAuthStore } from '@/stores/auth-store';

import { Show } from '../show';
import { WIZARD_STEPS } from '../wizard-tabs/steps';
import styles from './internal-mode-banner.module.css';

const WIZARD_PATHS = WIZARD_STEPS.map((s) => s.path);

/** NPJB-586: the Intelligence audience page carries its own "Creating on behalf of" bar. */
const AUDIENCE_PAGE = /^\/intelligence\/audiences(\/[^/]+)?\/?$/;

/**
 * Pale-blue strip shown under the nav for internal (Digitalzone) viewers (NPJB-403),
 * signalling the cross-account "DZ mode" context. Renders nothing for client
 * users, so it's safe to mount unconditionally in the app shell.
 *
 * Hidden on wizard routes (NPJB-415): the wizard swaps this read-context strip
 * for the interactive "Creating on behalf of" bar (`OnBehalfBar`). Hidden on the
 * Intelligence audience page too, which renders its own client picker there.
 */
export function InternalModeBanner() {
  const isInternal = useAuthStore((s) => s.isInternal);
  const { pathname } = useLocation();
  const insideWizard = WIZARD_PATHS.some((p) => pathname === p || pathname.startsWith(`${p}/`));
  const onAudiencePage = AUDIENCE_PAGE.test(pathname);
  return (
    <Show when={isInternal && !insideWizard && !onAudiencePage}>
      <Flex align='center' className={styles.banner}>
        <Text weight='semibold'>Viewing as Digitalzone</Text>
      </Flex>
    </Show>
  );
}
